export function getPageHtmlKey(projectId: string, pageRoute: string) {
  return `projects/${projectId}/pages/${pageRoute}.html`.replace(/\/+/g, "/");
}

export function getLayoutCssKey(projectId: string) {
  return `projects/${projectId}/layout.css`;
}

const CACHE_DOMAIN = "https://preview.replocdn.com";

export function getPageHtmlUrl(projectId: string, pageRoute: string) {
  return `${CACHE_DOMAIN}/${getPageHtmlKey(projectId, pageRoute)}`;
}

export function getLayoutCssUrl(projectId: string) {
  return `${CACHE_DOMAIN}/${getLayoutCssKey(projectId)}`;
}
